import { useQueryClient } from "react-query";

export default useQueryClient;
